import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationModule } from './modules/authentication/authentication.module';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'cop',
    loadChildren: () => import('./modules/cop/cop.module').then(m => m.CopModule)
  },
  {
    path: 'management',
    loadChildren: () => import('./modules/management/management.module').then(m => m.ManagementModule)
  },
  {
    path: 'incidents',
    loadChildren: () => import('./modules/incidents/incidents.module').then(m => m.IncidentsModule)
  },
  {
    path: 'communications',
    loadChildren: () => import('./modules/communications/communications.module').then(m => m.CommunicationsModule)
  },
  {
    path: 'analytics',
    loadChildren: () => import('./modules/analytics/analytics.module').then(m => m.AnalyticsModule)
  },
  {
    path: 'preferences',
    loadChildren: () => import('./modules/notification-prefs/notification-prefs.module').then(m => m.NotificationPrefsModule)
  },
  {
    path: 'confirmation',
    loadChildren: () =>
      import('./modules/notification-confirmation/notification-confirmation.module').then(m => m.NotificationConfirmationModule)
  },
  {
    path: 'error-messages',
    loadChildren: () => import('./modules/errorMessages/error-messages.module').then(m => m.ErrorMessagesModule)
  },
  {
    path: 'datasets',
    loadChildren: () => import('./modules/document-viewer/document-viewer.module').then(m => m.DocumentViewerModule)
  },
  {
    path: '',
    redirectTo: 'cop',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {}), AuthenticationModule],
  exports: [RouterModule]
})
export class AppRoutingModule {}
